<template>
  <div class="gl-wrap">
    <p class="company-name">北京电力设备总厂有限公司</p>
    <div id="con">
      <div class="small-camera-wrap" v-for="(item, index) in videoPath" :class="'camera'+index" :key="index">
        <div class="video-details-warp" :class="'position'+index">
          <!-- 视频窗口 -->
          <!-- <video 
          class="myPlayers" 
          :id="'myPlayers'+index" 
          :src=item.m3u8Address 
          controls 
          playsInline 
          webkit-playsinline 
          autoplay 
          muted>
          </video> -->
          <videoPlayer
            class="myPlayers"
            :videoPath="[item.m3u8Address,item.m3u8AddressHd]"
            :myPlayer="'myPlayers'+index" 
            :ref="'myPlayers'+index" 
            @idValue="resizeId"
            >
            </videoPlayer>
          <span class="title">{{item.name}}</span>
          <!--        <span class="iconfont-full" @click="showBigVideo(index)">-->
          <!--          <i class="el-icon-full-screen"></i>-->
          <!--        </span>-->
          <span class="iconfont-close" @click="closeSmallVideo(index)">
          <i class="el-icon-close"></i>
        </span>
        </div>
      </div>
    </div>
    <el-select v-model="companyId" @change="changeModel" class="info-select colorFFF">
      <el-option v-for="item in companyList" :label="item.divisionName" :value="item.id" :key="item.id"></el-option>
    </el-select>
    <div class="imgBox">
      <img src="../../../assets/images/视角旋转对齐.png" alt="" @click="rotation">
      <img src="../../../assets/images/视角切换_俯视视角.png" alt="" @click="overlook">
      <img src="../../../assets/images/摄像头.png" alt="" @click="camera">
      <img src="../../../assets/images/返回.png" alt="" @click="returnBack">
    </div>
<!--    <button class="move-btn" @click="transitionAnimation('', [-74278, 23366, 9979], [-7372, -9007, 12622],3000)"></button>-->
  </div>
</template>

<script>
import {pathFlow, rotateView, tick, transitionAnimation} from "../../../assets/js/tools/instruments";
import * as EZUIKit from "../../../assets/js/external/ezuikit";
import videoPlayer from "../../../components/3DVideoPlayer.vue";
import { getSession } from "../../../assets/js/tools/instruments";
export default {
    name: "video3d",
    components:{videoPlayer},
    data(){
      return{
        dataModel: null,          //数据容器
        graphView: null,           //2D
        g3d: null,
        dm: null,
        companyId: '',
        videoPath: [],
        videoToken: false,
        companyName: '北京电力设备总厂有限公司',
        roadLine: null,         //动画名称
        companyList: [],
        changeId:'',
        changeStatue:'',
        videoArr:[]
      }
    },
    watch: {
      // videoPath(val){
      //   this.$nextTick(function(){
      //     new EZUIKit.EZUIPlayer('myPlayer');
      //   })
      // },
      $route: {
        handler() {
          this.companyId = this.$route.query.id;
        },
        deep: true,
      },
      videoPath(val){
        this.$nextTick(function(){
          for(let i = 0; i < 6; i++) {
            let now = new EZUIKit.EZUIPlayer('myPlayers'+i);
            this.videoArr.push(now);
          }
        })
      },
    },
    beforeCreate() {
      window.htUrl('videoMonitor/storage');
    },
    beforeDestroy() {
      this.videoPath = '';
      this.videoArr.forEach(item => {
      item.stop();
    })
    this.videoData = [];
    },
    mounted() {
      let _this = this;
      //获取摄像头地址
      _this.$get('videomonitoring/getdivisionvediobyassetnumber', [_this.companyId?_this.companyId:7, 0])
          .then((res)=> {
            if (res.length !== 0) {
              _this.videoPath = res[0].children;
            }
          })
      // this.companyId = this.$route.query.id ? this.$route.query.id : '';
      this.addGraphView();
      this.getCompanyList();
      let that = this
       window.onresize = function () {
        if(that.changeStatue==1){
          that.changeStatue=2
          // that.$refs[that.changeId][0].fullClick()
        }else if(that.changeStatue==0){
          that.changeStatue=2
        }else if(that.changeStatue==2){
          that.$refs[that.changeId][0].fullClick0()
        }
      }
    },
    methods:{
      resizeId(e){
        this.changeId=e[0]
        this.changeStatue=e[1]
      },
      addGraphView() {
        this.dataModel = new ht.DataModel();  // 数据容器
        this.graphView = new ht.graph.GraphView(this.dataModel);  // 2d 绑定数据模型
        this.dm = this.graphView.dm();
        this.g3d = new ht.graph3d.Graph3dView();

        this.g3d.addToDOM(document.getElementById('con'));
        this.graphView.addToDOM(this.g3d.getView());
        let _this = this;
        this.graphView.deserialize('displays/board.json', function (json, dm, gv, datas) {

        })
        this.g3d.deserialize('scenes/2总厂缩放.json', function(json, dm, g3d, datas) {
          _this.g3d.setEye(-335399, 17970, 206073);
          _this.g3d.setCenter(-24984, -30463, 155380);
          _this.g3d.setFar(100000000);
          pathFlow(_this, 'roadLine', ['road1', 'road', 'road3', 'road4','road5'], 50,0.05,'top.uv.offset','move')
          // if(ht.Default.getShape3dModelMap()['models/11厂/北京电力设备总厂/办公楼.json']) {
          //   transitionAnimation(_this, [-74278, 23366, 9979], [-7372, -9007, 12622],3000)
          // } else {
          //   ht.Default.handleModelLoaded = function(name, model) {
          //     if(name == 'models/11厂/北京电力设备总厂/办公楼.json') {
          //       transitionAnimation(_this, [-74278, 23366, 9979], [-7372, -9007, 12622],3000)
          //     }
          //   }
          // }
          tick(_this,'tickAnmi',9500,10292,30,['大门','中控室','楼顶','一楼大厅','六分厂','七分厂'],'move')
        });
        let mapInteractor = new ht.graph3d.MapInteractor(this.g3d);
        this.g3d.setInteractors([mapInteractor]);
        ht.Default.graph3dViewMaxPhi=Math.PI/2;
        ht.Default.graph3dViewMinPhi=0;

        this.graphView.mi(this.buttonMonitor);
        this.g3d.mi(this.modelMonitor);
        // 监听滚轮运动
        var div2d = _this.graphView.getView();
        var handler = function(event){
          if(_this.graphView.getDataAt(event)){
            let camerasArr = _this.g3d.dm().getDataByTag('cameras').getChildren()._as;
            camerasArr.forEach((item, index) => {
              let p3 = item.p3();
              let p = _this.g3d.toViewPosition([p3[0], p3[1], p3[2]]);
              let element = document.querySelector('.position'+index)
              if(index === 0 ) {
                element.style.left = (p.x-320)+'px';
                element.style.top = (p.y-150)+'px';
              }
              // else if(index === 1) {
              //   element.style.left = (p.x+50)+'px';
              //   element.style.top = (p.y-150)+'px';
              // }
              else if(index === 1) {
                element.style.left = (p.x-320)+'px';
                element.style.top = (p.y-50)+'px';
              } else if(index === 2) {
                element.style.left = (p.x+50)+'px';
                element.style.top = (p.y-150)+'px';
              } else if(index === 3) {
                element.style.left = (p.x+50)+'px';
                element.style.top = (p.y-150)+'px';
              } else if(index === 4) {
                element.style.left = (p.x-280)+'px';
                element.style.top = (p.y-150)+'px';
              } else if(index === 5) {
                element.style.left = (p.x+50)+'px';
                element.style.top = (p.y-150)+'px';
              }
            })
          }
        }
        div2d.addEventListener(getWheelEventName(div2d), handler)
        function getWheelEventName(element){
          if('onwheel' in element){
            return 'wheel';
          }else if(document.onmousewheel !== undefined){
            return 'mousewheel';
          }else{
            return 'DOMMouseScroll';
          }
        }

        this.event = new ht.Notifier();
      },
      transitionAnimation,
      getCompanyList(){
        this.$get('gisoverview/getdivisionlist', [0])
            .then((res)=>{
              this.companyList = res;
              this.companyId = this.$route.query.id ? this.$route.query.id : res[1].id;
            })
      },
      changeModel(id) {
        // if(id == '6') {
        //   this.$router.push({path: `/zhuangbei3d`, query: {id}});
        // } else if(id == '7') {
        //   this.$router.push({path: `/video3d`, query: {id}});
        // } else if(id == '70') {
        //   this.$router.push({path: `/empty`, query: {id}});
        // } else if(id == '71') {
        //   this.$router.push({path: `/empty`, query: {id}});
        // } else if(id == '72') {
        //   this.$router.push({path: `/nanjing3d`, query: {id}});
        // } else if(id == '73') {
        //   this.$router.push({path: `/empty`, query: {id}});
        // } else if(id == '74') {
        //   this.$router.push({path: `/empty`, query: {id}});
        // } else if(id == '75') {
        //   this.$router.push({path: `/empty`, query: {id}});
        // } else if(id == '76') {
        //   this.$router.push({path: `/empty`, query: {id}});
        // } else if(id == '77') {
        //   this.$router.push({path: `/empty`, query: {id}});
        // } else if(id == '78') {
        //   this.$router.push({path: `/empty`, query: {id}});
        // } else if(id == '79') {
        //   this.$router.push({path: `/empty`, query: {id}});
        // }
        // this.$router.push({path: `/video3d`});
         if(id == '6') {
          this.$router.push({path: `/zhuangbei3d`, query: {id}});
        } else if(id == '7') {
          this.$router.push({path: `/video3d`, query: {id}});
        } else if(id == '72') {
          this.$router.push({path: `/nanjing3d`, query: {id}});
        }else{
          this.$router.push({path: `/empty`, query: {id}});
        }
      },
      /*
      * 视频名称列表及交互
      * */
      videoMonitor(  ){
        let _this = this;
        let updateVideoPosition = function () {
          let camerasArr = _this.g3d.dm().getDataByTag('cameras').getChildren()._as;
          camerasArr.forEach((item, index) => {
            let p3 = item.p3();
            let p = _this.g3d.toViewPosition([p3[0], p3[1], p3[2]]);
            let element = document.querySelector('.position'+index)
            if(index === 0 ) {
              element.style.left = (p.x-320)+'px';
              element.style.top = (p.y-150)+'px';
            } else if(index === 1) {
              element.style.left = (p.x-320)+'px';
              element.style.top = (p.y-50)+'px';
            } else if(index === 2) {
              element.style.left = (p.x+50)+'px';
              element.style.top = (p.y-150)+'px';
            } else if(index === 3) {
              element.style.left = (p.x+50)+'px';
              element.style.top = (p.y-150)+'px';
            } else if(index === 4) {
              element.style.left = (p.x-280)+'px';
              element.style.top = (p.y-150)+'px';
            } else if(index === 5) {
              element.style.left = (p.x+50)+'px';
              element.style.top = (p.y-150)+'px';
            }
          });
        };
        let cameraInfos = [
          {
            name: '北京设备厂-大门',
            deviceNum: '080100016'
          },
          // {
          //   name: '北京设备厂-大厅',
          //   deviceNum: '080100017'
          // },
          {
            name: '北京设备厂-中控室',
            deviceNum: '080100018'
          },
          {
            name: '北京设备厂-楼顶',
            deviceNum: '080100021'
          },
          {
            name: '北京设备厂-一楼大厅',
            deviceNum: '080100062'
          },
          {
            name: '北京设备厂-六分厂',
            deviceNum: '080100070'
          },
          {
            name: '北京设备厂-七分厂',
            deviceNum: '080100071'
          },
          // {
          //   name: '北京设备厂-200T',
          //   deviceNum: '080100073'
          // },
        ];
        let camerasArr = _this.g3d.dm().getDataByTag('cameras').getChildren()._as;
        let lineArr = _this.g3d.dm().getDataByTag('connecting-line').getChildren()._as;
        camerasArr.forEach((item, index) => {
          let p3 = item.p3();
          lineArr[index].p3(p3);
        })
        let camera_table = _this.dm.getDataByTag('video-list');   //摄像头列表
        camera_table.a('ht.dataSource', cameraInfos);
        // transitionAnimation(_this, [-3584, 1875, 4280], [-3920, 241, 2989],4000)
        // camera_table.a('ht.onHoverCell', function(event, cell, row, column, rowIndex, colIndex, data, view) {
        //   for(let i = 0; i < cameraInfos.length; i++) {
        //     if(row){
        //       if(row.name === cameraInfos[i].name) {
        //         let cameraModel = _this.g3d.dm().getDataByTag(row.name);
        //         let view = cameraModel.getChildren()._as[0];
        //         setVisible(view, true);
        //       } else {
        //         let cameraModel = _this.g3d.dm().getDataByTag( cameraInfos[i].name );
        //         cameraModel.s('3d.visible', true);
        //         let view = cameraModel.getChildren()._as[0];
        //         setVisible(view, false);
        //       }
        //     }else{
        //       let cameraModel = _this.g3d.dm().getDataByTag( cameraInfos[i].name );
        //       cameraModel.s('3d.visible', true);
        //       let view = cameraModel.getChildren()._as[0];
        //       setVisible(view, false);
        //     }
        //   }
        // });
        camera_table.a('ht.onClickCell', function(event, cell, row, column, rowIndex, colIndex, data, view) {
          camera_table.a('ht.drawRow', function (g, row, rowindex, rect) {
            if (rowindex == rowIndex) {
              g.fillStyle = 'rgba(0,61,145,0.60)'
              g.fillRect(rect.x, rect.y, rect.width, rect.height);
            } else {
              g.fillStyle = 'rgba(14,26,54,0.70)'
              g.fillRect(rect.x, rect.y, rect.width, rect.height);
            }
          });
          if(rowIndex === 0) {
            transitionAnimation(_this, [-455434, 97368, 129214], [-56670, -50860, 99430],3000, function() {
              transitionAnimation(_this, [-434996, 67035, 257044],[-56670, -50860, 9943], 3000,function () {
                let element = document.querySelector('.camera0')
                element.style.cssText = 'display:block';
                _this.g3d.dm().getDataByTag('connecting-line').getChildren()._as[0].s('3d.visible', true);
              }, updateVideoPosition)
            }, updateVideoPosition)
            _this.$refs['myPlayers'+rowIndex][0].changeAutoplay()
          }
          // else if(rowIndex === 1) {
          //   transitionAnimation(_this, [-32323, 397, 25338], [-32258, 364, 25384],3000,function (rowIndex) {
          //     let element = document.querySelector('.camera1')
          //     element.style.cssText = 'display:block';
          //     _this.g3d.dm().getDataByTag('connecting-line').getChildren()._as[1].s('3d.visible', true);
          //   }, updateVideoPosition)
          // }
          else if(rowIndex === 1) {
            transitionAnimation(_this, [-380811, 68620, 160702], [-56670, -50860, 99430],3000, function() {
              transitionAnimation(_this, [-236052, 3985, 171544], [-236157, 1964, 168013],3000,function (rowIndex) {
                let element = document.querySelector('.camera1')
                element.style.cssText = 'display:block';
                _this.g3d.dm().getDataByTag('connecting-line').getChildren()._as[1].s('3d.visible', true);
              }, updateVideoPosition)
            }, updateVideoPosition)
            _this.$refs['myPlayers'+rowIndex][0].changeAutoplay()
          } else if(rowIndex === 2) {
            transitionAnimation(_this, [-380811, 68620, 160702], [-56670, -50860, 99430],3000, function() {
              transitionAnimation(_this, [-119772,51607 , 177551], [-245311, 17989, 173581],3000,function (rowIndex) {
                let element = document.querySelector('.camera2')
                element.style.cssText = 'display:block';
                _this.g3d.dm().getDataByTag('connecting-line').getChildren()._as[2].s('3d.visible', true);
              }, updateVideoPosition)
            }, updateVideoPosition)
            _this.$refs['myPlayers'+rowIndex][0].changeAutoplay()
          } else if(rowIndex === 3) {
            transitionAnimation(_this, [-380811, 68620, 160702], [-56670, -50860, 99430],3000, function() {
              transitionAnimation(_this, [-208269, 2592, 177924], [-207950, 2266, 25849],3000,function (rowIndex) {
                let element = document.querySelector('.camera3')
                element.style.cssText = 'display:block';
                _this.g3d.dm().getDataByTag('connecting-line').getChildren()._as[3].s('3d.visible', true);
              }, updateVideoPosition)
            }, updateVideoPosition)
            _this.$refs['myPlayers'+rowIndex][0].changeAutoplay()
          } else if(rowIndex === 4) {
            transitionAnimation(_this, [-380811, 68620, 160702], [-56670, -50860, 99430],3000, function() {
              transitionAnimation(_this, [246058, 97496, 8940], [-133512, -15716, -99835],3000,function (rowIndex) {
                let element = document.querySelector('.camera4')
                element.style.cssText = 'display:block';
                _this.g3d.dm().getDataByTag('connecting-line').getChildren()._as[4].s('3d.visible', true);
              }, updateVideoPosition)
            }, updateVideoPosition)
            _this.$refs['myPlayers'+rowIndex][0].changeAutoplay()
          } else if(rowIndex === 5) {
            transitionAnimation(_this, [-380811, 68620, 160702], [-56670, -50860, 99430],3000, function() {
              transitionAnimation(_this, [41543, 26651, 25550], [150200, -16465, 81918],3000,function (rowIndex) {
                let element = document.querySelector('.camera5')
                element.style.cssText = 'display:block';
                _this.g3d.dm().getDataByTag('connecting-line').getChildren()._as[5].s('3d.visible', true);
              }, updateVideoPosition)
            }, updateVideoPosition)
            _this.$refs['myPlayers'+rowIndex][0].changeAutoplay()
          }
        });
      },
      modelMonitor(e) {
        const { kind, data } = e;
        let _this = this;
        let camera_table = this.dm.getDataByTag('video-list');   //摄像头列表
        let updateVideoPosition = function () {
          let camerasArr = _this.g3d.dm().getDataByTag('cameras').getChildren()._as;
          camerasArr.forEach((item, index) => {
            let p3 = item.p3();
            let p = _this.g3d.toViewPosition([p3[0], p3[1], p3[2]]);
            let element = document.querySelector('.position'+index)
            if(index === 0 ) {
              element.style.left = (p.x-320)+'px';
              element.style.top = (p.y-150)+'px';
            } else if(index === 1) {
              element.style.left = (p.x-320)+'px';
              element.style.top = (p.y-50)+'px';
            } else if(index === 2) {
              element.style.left = (p.x+50)+'px';
              element.style.top = (p.y-150)+'px';
            } else if(index === 3) {
              element.style.left = (p.x+50)+'px';
              element.style.top = (p.y-150)+'px';
            } else if(index === 4) {
              element.style.left = (p.x-280)+'px';
              element.style.top = (p.y-150)+'px';
            } else if(index === 5) {
              element.style.left = (p.x+50)+'px';
              element.style.top = (p.y-150)+'px';
            }
          });
        };
        // 更新视频监控窗口坐标
        let camerasArr = this.g3d.dm().getDataByTag('cameras').getChildren()._as;
        camerasArr.forEach((item, index) => {
          let p3 = item.p3();
          let p = this.g3d.toViewPosition([p3[0], p3[1], p3[2]]);
          let element = document.querySelector('.position'+index)
          if(index === 0 ) {
            element.style.left = (p.x-320)+'px';
            element.style.top = (p.y-150)+'px';
          } else if(index === 1) {
            element.style.left = (p.x-320)+'px';
            element.style.top = (p.y-50)+'px';
          } else if(index === 2) {
            element.style.left = (p.x+50)+'px';
            element.style.top = (p.y-150)+'px';
          } else if(index === 3) {
            element.style.left = (p.x+50)+'px';
            element.style.top = (p.y-150)+'px';
          } else if(index === 4) {
            element.style.left = (p.x-280)+'px';
            element.style.top = (p.y-150)+'px';
          } else if(index === 5) {
            element.style.left = (p.x+50)+'px';
            element.style.top = (p.y-150)+'px';
          }
        })
        if(kind === 'clickData'){
          camera_table.a('ht.drawRow', function (g, row, rowIndex, rect) {
            if (row.name.search(data._tag) !== -1) {
              g.fillStyle = 'rgba(0,61,145,0.60)'
              g.fillRect(rect.x, rect.y, rect.width, rect.height);
            } else {
              g.fillStyle = 'rgba(14,26,54,0.70)'
              g.fillRect(rect.x, rect.y, rect.width, rect.height);
            }
          });
          if(data._parent._displayName=='9-九分厂'){
            const menuList = JSON.parse(getSession('menuList'));
            const bool1 = menuList.some(item=> item.menuName == '智慧车间');
            if (bool1){
              this.$router.push('/nineBranchFactory');
            }
            // 
          }
          if(data._tag === '大门') {
            transitionAnimation(_this, [-46936, 29983, -5140], [1568, -8532, 13960],3000, function() {
              transitionAnimation(_this, [-67061, 10386, 41549], [-62842, 9008, 38611],3000,function () {
                let element = document.querySelector('.camera0')
                element.style.cssText = 'display:block';
                _this.g3d.dm().getDataByTag('connecting-line').getChildren()._as[0].s('3d.visible', true);
              }, updateVideoPosition)
            }, updateVideoPosition)
          }
          // else if(data._tag === '大厅') {
          //   transitionAnimation(_this, [-32323, 397, 25338], [-32258, 364, 25384],3000,function (rowIndex) {
          //     // let p3 = camerasArr[1].p3();
          //     // let p = _this.g3d.toViewPosition([p3[0], p3[1], p3[2]]);
          //     // let element1 = document.querySelector('.position1')
          //     // element1.style.left = (p.x+50)+'px';
          //     // element1.style.top = (p.y-150)+'px';
          //     let element = document.querySelector('.camera1')
          //     element.style.cssText = 'display:block';
          //     _this.g3d.dm().getDataByTag('connecting-line').getChildren()._as[1].s('3d.visible', true);
          //   }, updateVideoPosition)
          // }
          else if(data._tag === '中控室') {
            transitionAnimation(_this, [-46936, 29983, -5140], [1568, -8532, 13960],3000, function() {
              transitionAnimation(_this, [-38010, 543, 25792], [-38056, 385, 25580],3000,function (rowIndex) {
                let element = document.querySelector('.camera1')
                element.style.cssText = 'display:block';
                _this.g3d.dm().getDataByTag('connecting-line').getChildren()._as[1].s('3d.visible', true);
              }, updateVideoPosition)
            }, updateVideoPosition)
          }  else if(data._tag === '楼顶') {
            transitionAnimation(_this, [-46936, 29983, -5140], [1568, -8532, 13960],3000, function() {
              transitionAnimation(_this, [-34375, 5421, 25402], [-36765, 3275, 27096],3000,function (rowIndex) {
                let element = document.querySelector('.camera2')
                element.style.cssText = 'display:block';
                _this.g3d.dm().getDataByTag('connecting-line').getChildren()._as[2].s('3d.visible', true);
              }, updateVideoPosition)
            }, updateVideoPosition)
          } else if(data._tag === '一楼大厅') {
            transitionAnimation(_this, [-46936, 29983, -5140], [1568, -8532, 13960],3000, function() {
              transitionAnimation(_this, [-34551, 674, 26312], [-34363, 490, 25849],3000,function (rowIndex) {
                let element = document.querySelector('.camera3')
                element.style.cssText = 'display:block';
                _this.g3d.dm().getDataByTag('connecting-line').getChildren()._as[3].s('3d.visible', true);
              }, updateVideoPosition)
            }, updateVideoPosition)
          } else if(data._tag === '六分厂') {
            transitionAnimation(_this, [-46936, 29983, -5140], [1568, -8532, 13960],3000, function() {
              transitionAnimation(_this, [25830, 1223, -5843], [25808, 1216, -5853],3000,function (rowIndex) {
                let element = document.querySelector('.camera4')
                element.style.cssText = 'display:block';
                _this.g3d.dm().getDataByTag('connecting-line').getChildren()._as[4].s('3d.visible', true);
              }, updateVideoPosition)
            }, updateVideoPosition)
          } else if(data._tag === '七分厂') {
            transitionAnimation(_this, [-46936, 29983, -5140], [1568, -8532, 13960],3000, function() {
              transitionAnimation(_this, [-3049, 785, 10731], [-3113, 755, 10795],3000,function (rowIndex) {
                let element = document.querySelector('.camera5')
                element.style.cssText = 'display:block';
                _this.g3d.dm().getDataByTag('connecting-line').getChildren()._as[5].s('3d.visible', true);
              }, updateVideoPosition)
            }, updateVideoPosition)
          }
        }
      },
      jumpNine(){

      },
      buttonMonitor(e){
        const { kind, data } = e;
        let _this = this;
        let pointTagArr = ['return','camera','overlook','rotation']
        if (kind === "onEnter"){
          let tag = data.getTag();
          pointTagArr.forEach(item => {
            if(tag === item) {
              _this.graphView.getView().style.cursor = "pointer";
            }
          })
        }else if( kind === "onLeave" ){
          let tag = data.getTag();
          pointTagArr.forEach(item => {
            if(tag === item) {
              _this.graphView.getView().style.cursor = "default";
            }
          })
        }else if(kind === 'clickData'){
          let tag = data.getTag();
          this.rotate_anim ? this.rotate_anim.stop(true) : null;
          if( tag == 'return' ){
            this.rotate_flag = false;
            _this.$router.push({path: '/GISOverview', query: {id: this.$route.query.id}});
          }else if(tag == 'camera'){
            this.rotate_flag = false;
            _this.videoToken = !_this.videoToken;
            let cameraBtn =  _this.dm.getDataByTag('camera');     //摄像头控制按钮
            let officeBuilding = this.g3d.dm().getDataByTag('officeBuilding');      //办公楼模型
            let tickArr = ['大门','中控室','楼顶','一楼大厅','六分厂','七分厂'];
            if(_this.videoToken){
              cameraBtn.s('body.color', '#3deee7');
              _this.dm.getDataByTag('video-list').s('2d.visible', true);
              officeBuilding.s({'wf.geometry': false, "3d.clip.direction": "front"});   //关闭几何线条
              _this.videoMonitor();
              tickArr.forEach(tag => {
                let model = this.g3d.dm().getDataByTag(tag);
                model.s('3d.visible', true);
              })
            }else{
              cameraBtn.s('body.color', '#ffffff');
              _this.dm.getDataByTag('video-list').s('2d.visible', false);
              officeBuilding.s({'wf.geometry': true, "3d.clip.direction": ""});   //关闭几何线条
              for(let i of document.querySelectorAll('.small-camera-wrap')) {
                i.style.cssText = 'display:none';
              }
              this.g3d.dm().getDataByTag('connecting-line').getChildren()._as.forEach(item => {
                item.s('3d.visible', false);
              })
              tickArr.forEach(tag => {
                let model = this.g3d.dm().getDataByTag(tag);
                model.s('3d.visible', false);
              })
            }
          } else if(tag === 'overlook') {
            this.rotate_flag = false;
            transitionAnimation(_this, [-406550, 59658, 153999], [-207950, 2266, 171446],3000)
          }  else if(tag === 'rotation') {
            if(this.rotate_flag) {
              this.rotate_anim ? this.rotate_anim.stop(true) : null;
              this.rotate_flag = false;
            } else {
              this.g3d.setEye(-507876, 283281, 184007);
              this.g3d.setCenter(45001, 6501, -66643);
              rotateView(_this);
              this.rotate_flag = true;
            }
          }
        }
      },
      overlook(){
        let _this = this;
        this.rotate_anim ? this.rotate_anim.stop(true) : null;
        this.rotate_flag = false;
        transitionAnimation(this, [-406550, 59658, 153999], [-207950, 2266, 171446],3000)
      },

      rotation(){
        let _this = this;
        this.rotate_anim ? this.rotate_anim.stop(true) : null;
        if(this.rotate_flag) {
          this.rotate_anim ? this.rotate_anim.stop(true) : null;
          this.rotate_flag = false;
        } else {
          this.g3d.setEye(-507876, 283281, 184007);
          this.g3d.setCenter(45001, 6501, -66643);
          rotateView(_this);
          this.rotate_flag = true;
        }
      },
      returnBack(){
        let _this = this;
        this.rotate_flag = false;
        this.rotate_anim ? this.rotate_anim.stop(true) : null;
        this.$router.push({path: '/GISOverview', query: {id: this.$route.query.id}});
      },
      camera(){
        let _this = this;
        this.rotate_anim ? this.rotate_anim.stop(true) : null;
        this.rotate_flag = false;
            _this.videoToken = !_this.videoToken;
            let cameraBtn =  _this.dm.getDataByTag('camera');     //摄像头控制按钮
            let officeBuilding = this.g3d.dm().getDataByTag('officeBuilding');      //办公楼模型
            let tickArr = ['大门','中控室','楼顶','一楼大厅','六分厂','七分厂'];
            if(_this.videoToken){
              cameraBtn.s('body.color', '#3deee7');
              _this.dm.getDataByTag('video-list').s('2d.visible', true);
              officeBuilding.s({'wf.geometry': false, "3d.clip.direction": "front"});   //关闭几何线条
              _this.videoMonitor();
              tickArr.forEach(tag => {
                let model = this.g3d.dm().getDataByTag(tag);
                model.s('3d.visible', true);
              })
            }else{
              cameraBtn.s('body.color', '#ffffff');
              _this.dm.getDataByTag('video-list').s('2d.visible', false);
              officeBuilding.s({'wf.geometry': true, "3d.clip.direction": ""});   //关闭几何线条
              for(let i of document.querySelectorAll('.small-camera-wrap')) {
                i.style.cssText = 'display:none';
              }
              this.g3d.dm().getDataByTag('connecting-line').getChildren()._as.forEach(item => {
                item.s('3d.visible', false);
              })
              tickArr.forEach(tag => {
                let model = this.g3d.dm().getDataByTag(tag);
                model.s('3d.visible', false);
              })
            }
      },
      closeSmallVideo(index){
        this.videoArr[index].pause()
        document.querySelector('.camera'+index).style.cssText = 'display:none';
        this.g3d.dm().getDataByTag('connecting-line').getChildren()._as[index].s('3d.visible', false);
      },
      // 视频窗口
      move(e){
        let odiv = e.target;// 获取目标元素
        let close_btn = document.querySelector('.videoDetails-warp span');
        //计算出鼠标相对点击元素的位置,e.clientX获取的是鼠标的位置，OffsetLeft是元素相对于外层元素的位置
        let x = e.clientX - odiv.offsetLeft;
        let y = e.clientY - odiv.offsetTop;
        document.onmousemove = (e) => {
          // 获取拖拽元素的位置
          let left = e.clientX - x;
          let top = e.clientY - y;
          this.positionX = left;
          this.positionY = top;
          odiv.style.left = left + "px";
          odiv.style.top = top + "px";
        }
        // 为了防止 火狐浏览器 拖拽阴影问题
        document.onmouseup = (e) => {
          document.onmousemove = null;
          document.onmouseup = null
        }
      },
      closeVideo(){
        document.getElementsByClassName('camera-wrap')[0].style.cssText = 'display:none';
      },
    }
  }
</script>

<style scoped lang="scss">
.gl-wrap{
  width: 100%;
  height: 100%;
  position: relative;
  .company-name{
    position: absolute;
    top: 0;
    left: 45%;
    //width: 80%;
    text-align: center;
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    color: #fff;
    z-index: 9999;
    letter-spacing: 2px;
  }
  #con{
    width: 100%;
    height: calc(100vh - 100px);
    position: relative;
    .small-camera-wrap{
      position: absolute;
      top: 0;
      left: 0;
      width: 10%;
      height: 10%;
      display: none;
      .video-details-warp{
        position: absolute;
        padding: 24px 10px 10px;
        z-index: 99999;
        background: #131831e6;
        border: 1px solid rgba(7, 136, 206, 0.7);
        .myPlayers{
          width: 250px;
          height: 150px;
        }
        span{
          color: #eaeaea;
          //font-size: 13px;
          position: absolute;
          top: 5px;
          z-index: 950000;
          cursor: pointer;
        }
        .title {
          left: 10px;
          cursor: default;
        }
        .iconfont-full{
          right: 20px;
        }
        .iconfont-close{
          right: 3px;
        }
      }
    }
  }
  .info-select {
    position: absolute;
    right: 240px;
    top: 15px;
  }
  .imgBox{
    position: absolute;
    right: 30px;
    top: 15px;
    img{
      padding-left: 10px;
      width: 50px;
      height: 40px;
      cursor:pointer;
    }
  }
  .move-btn{
    position: absolute;
    bottom: 0;
    right: 0;
    background: #00112d;
    cursor: pointer;
    border: none;
    outline: none;
    z-index: 9999;
    width: 25px;
  }

  //.camera-wrap{
  //  position: absolute;
  //  top: 0;
  //  left: 0;
  //  width: 100%;
  //  height: 100%;
  //  z-index: 999999;
  //  display: none;
  //  .video-details-warp{
  //    position: absolute;
  //    top: 16%;
  //    left: 27%;
  //    padding: 20px;
  //    z-index: 999999;
  //    background: #12162b;
  //    p{
  //      color: #fff;
  //      font-size: 16px;
  //      margin: 0;
  //    }
  //    #myPlayer {
  //      margin-top: 25px;
  //      width: 850px;
  //      height: 570px;
  //      z-index: 999999;
  //    }
  //    span{
  //      color: #fff;
  //      position: absolute;
  //      top: 16px;
  //      right: 25px;
  //      z-index: 999999;
  //      cursor: pointer;
  //    }
  //  }
  //}
}
</style>
